import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppRouter from './router/AppRouter';
import { AuthProvider } from './context/AuthContext';
import { PwaInstallProvider } from './hooks/usePwaInstall';
import InstallPrompt from './components/InstallPrompt';

function App() {
  return (
    <AuthProvider>
      <PwaInstallProvider>
        <BrowserRouter>
          <AppRouter />
          <InstallPrompt />
        </BrowserRouter>
      </PwaInstallProvider>
    </AuthProvider>
  );
}

export default App;
